import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App';
import MiddlewareLoader from '@/routes/middleware-loader';
import VueSuggestion from 'vue-suggestion';
import Suggestions from 'v-suggestions';
import VueMask from 'v-mask';
import 'v-suggestions/dist/v-suggestions.css' // you can import the stylesheets also (optional)
import { setupInterceptors } from './services/httpInterceptors';

// Vue Notification
import Notifications from 'vue-notification';
import velocity from 'velocity-animate';
import money from 'v-money';
import firebaseApp from './libs/firebaseApp';

// router setup
import routes from './routes/routes';

// store setup
import store from './store';

// Plugins
import GlobalComponents from './globalComponents';
import GlobalDirectives from './globalDirectives';

// MaterialDashboard plugin
import MaterialDashboard from './material-dashboard';

import Chartist from 'chartist';
import vuetify from './plugins/vuetify';
import moment from 'moment'

// configure router
const router = new VueRouter({
	mode: 'history',
	routes, // short for routes: routes
	linkExactActiveClass: 'nav-item active'
});

router.beforeEach((to, from, next) => {
	return MiddlewareLoader(to, from, next);
});

Vue.prototype.$Chartist = Chartist;
Vue.prototype.$firebaseApp = firebaseApp;

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(VueSuggestion);
Vue.component('suggestions', Suggestions);
Vue.use(Notifications, { velocity });
Vue.use(VueMask);
Vue.use(money, 
	{
		decimal: ',',
		thousands: '.',
		prefix: 'Rp. ',
		precision: 2
	}
)
/* eslint-disable no-new */
new Vue({
	el: '#app',
	render: (h) => h(App),
	created() {
		setupInterceptors(store);
	},
	router,
	store,
	vuetify,
    firebaseApp,
	data: {
		Chartist: Chartist
	}
});
